module.exports = __webpack_public_path__ + "static/family_office_01-7285d0d55fc5db6552a5c76a3652afd6.svg";